// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aACYuHT7V4nwxKmM6nYF {
  background: var(--header-elevation) !important;
  padding: 0px !important;
  width: 350px !important;
  text-align: left !important;
  opacity: 1 !important;
  box-shadow: 0 3px 8px -1px rgba(50, 50, 71, 0.05);
  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));
  border-radius: 5px;
}

.e_ka2NfG6eNHpbAbhYyZ {
  color: var(--header-title-main);
  font-size: 14px;
  padding: 25px;
}

.ne3y64lEywwYJobEd39A {
  padding: 0 25px 20px 25px;
  display: flex;
  flex-direction: column;
  row-gap: 25px;
}

._IcCQZKiZncC9dfmjoPx {
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  display: block;
  margin-bottom: 8px;
}

.mDBKjHoQTVQhrFHEdeGw .input-field {
  max-width: 90px !important;
}

.va422iANtAIU0alkEW2D {
  font-size: 12px;
  line-height: 20px;
  color: var(--title-inputs-sections-title);
  padding-right: 5px;
}

.hxPOOpndfc_j_BDtyjZx,
._kCpP4uYmaI6HbypDtHx {
  display: none;
}
@media (max-width: 1440px) {
  .hxPOOpndfc_j_BDtyjZx,
  ._kCpP4uYmaI6HbypDtHx {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./../src/pages/Archive/components/AdditionalFilters/style.modules.scss"],"names":[],"mappings":"AA0EA;EAEE,8CAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,qBAAA;EACA,iDAAA;EACA,mDAAA;EACA,kBAAA;AA1EF;;AA6EA;EACE,+BAAA;EACA,eAAA;EACA,aAAA;AA1EF;;AA6EA;EACE,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AA1EF;;AA6EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yCAAA;EACA,cAAA;EACA,kBAAA;AA1EF;;AA+EI;EACE,0BAAA;AA5EN;;AAiFA;EACE,eAAA;EACA,iBAAA;EACA,yCAAA;EACA,kBAAA;AA9EF;;AAiFA;;EAEE,aAAA;AA9EF;AA+EE;EAHF;;IAII,cAAA;EA3EF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.additionalFilters {\n  // importants below to overwrite react-tooltip styles\n  background: var(--header-elevation) !important;\n  padding: 0px !important;\n  width: 350px !important;\n  text-align: left !important;\n  opacity: 1 !important;\n  box-shadow: 0 3px 8px -1px rgba(50, 50, 71, 0.05);\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 5px;\n}\n\n.tooltipTitle {\n  color: var(--header-title-main);\n  font-size: 14px;\n  padding: 25px;\n}\n\n.filters {\n  padding: 0 25px 20px 25px;\n  display: flex;\n  flex-direction: column;\n  row-gap: 25px;\n}\n\n.fieldLabel {\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 12px;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  display: block;\n  margin-bottom: 8px;\n}\n\n.slideRangeFieldWrapper {\n  :global {\n    .input-field {\n      max-width: 90px !important;\n    }\n  }\n}\n\n.startAdornment {\n  font-size: 12px;\n  line-height: 20px;\n  color: var(--title-inputs-sections-title);\n  padding-right: 5px;\n}\n\n.averageTime,\n.datepickerLastUpdateRange {\n  display: none;\n  @media (max-width: 1440px) {\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"additionalFilters": `aACYuHT7V4nwxKmM6nYF`,
	"tooltipTitle": `e_ka2NfG6eNHpbAbhYyZ`,
	"filters": `ne3y64lEywwYJobEd39A`,
	"fieldLabel": `_IcCQZKiZncC9dfmjoPx`,
	"slideRangeFieldWrapper": `mDBKjHoQTVQhrFHEdeGw`,
	"startAdornment": `va422iANtAIU0alkEW2D`,
	"averageTime": `hxPOOpndfc_j_BDtyjZx`,
	"datepickerLastUpdateRange": `_kCpP4uYmaI6HbypDtHx`
};
export default ___CSS_LOADER_EXPORT___;
